'use strict';
angular.module('schoolLinqApp').factory('transactionhistoryService', [
	'$http',
	'$q',
	function ($http, $q) {
		var endpoint = '/api/transactionHistory';

		function getBudgets(year) {
			return $http.get(endpoint + '/getBudgets', { params: { year: year } });
		}

		function getALBudgets(year) {
			return $http.get(endpoint + '/getALBudgets', { params: { year: year } });
		}

		function getALBudgetsInfo(year) {
			return $http.get(endpoint + '/getALBudgetsInfo', {
				params: { year: year },
			});
		}

		function search(filter, accountId, includeVendorName) {
			return $http.get(endpoint + '/search', {
				params: {
					journalTypeId: filter.journalTypeId,
					accountId: accountId ? accountId : null,
					year: filter.fiscalYear ? filter.fiscalYear : null,
					from: filter.from,
					to: filter.to,
					journalcode: filter.journalCode,
					thirteenth: filter.thirteenth,
					refNo: filter.refNo,
					groupByRefNo: filter.groupByRefNo,
					includeVendorName: includeVendorName,
				},
			});
		}

		function getFiscalYears() {
			return $http.get(endpoint + '/historyFiscalYears');
		}

		function getFiscalYearsByAccount(acountId) {
			return $http.get(endpoint + '/fiscalYearsByAccount', {
				params: { accountId: acountId },
			});
		}

		function saveBudgets(year, transactions) {
			return $http.post(endpoint + '/save-budgets', transactions, {
				params: { year: year },
			});
		}

		function finalizeBudgets(finalizeModel) {
			return $http.post(endpoint + '/finalizeBudgets', finalizeModel);
		}

		function saveBeginningBalance(year, transactions) {
			return $http.post(endpoint + '/beginningBalances', transactions, {
				params: { year: year },
			});
		}

		function addJournalEntries(transactions) {
			return $http.post(endpoint + '/journalEntries', transactions);
		}

		function addSavedJournalEntries(transactions) {
			return $http.post(endpoint + '/addSavedJournalEntries', transactions);
		}

		function deleteSavedJournalEntries(transactionGuid) {
			return $http.delete(endpoint + '/deleteSavedJournalEntries', {
				params: { transactionGuid: transactionGuid },
			});
		}

		function getSavedJournalEntries() {
			return $http.get(endpoint + '/getSavedJournalEntries');
		}

		function getSavedJournalEntriesCount() {
			return $http.get(endpoint + '/getSavedJournalEntriesCount');
		}

		function getNextReferenceNo() {
			return $http.get(endpoint + '/nextReferenceNo');
		}

		function getMoreDetailedAccountHistory(transactionId) {
			return $http.get(endpoint + '/getMoreDetailedAccountHistory', {
				params: { transactionId: transactionId },
			});
		}

		return {
			getFiscalYears: getFiscalYears,
			getBudgets: getBudgets,
			getALBudgets: getALBudgets,
			getALBudgetsInfo: getALBudgetsInfo,
			saveBudgets: saveBudgets,
			finalizeBudgets: finalizeBudgets,
			saveBeginningBalance: saveBeginningBalance,
			search: search,
			addJournalEntries: addJournalEntries,
			addSavedJournalEntries: addSavedJournalEntries,
			deleteSavedJournalEntries: deleteSavedJournalEntries,
			getSavedJournalEntries: getSavedJournalEntries,
			getSavedJournalEntriesCount: getSavedJournalEntriesCount,
			getFiscalYearsByAccount: getFiscalYearsByAccount,
			getNextReferenceNo: getNextReferenceNo,
			getMoreDetailedAccountHistory: getMoreDetailedAccountHistory,
		};
	},
]);
